import CsvTableWorker from './csvTable.worker?worker';

export const createCsvTableWorker = () => new CsvTableWorker();
